import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RpcButtonComponent } from '../../../../../core-modules/controls/components/rpc-button/rpc-button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'profile-toolbar',
    templateUrl: './profile-toolbar.component.html',
    styleUrls: ['./profile-toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RpcButtonComponent, TranslateModule]
})
export class ProfileToolbarComponent {
    @Input() public isAdditionalProfile: boolean;
    @Input() public isMinimized?: boolean = false;

    @Output() public edit = new EventEmitter<void>();
    @Output() public navigateBack = new EventEmitter<void>();

    public onNavigateBack(): void {
        this.navigateBack.emit();
    }

    public onEdit(): void {
        this.edit.emit();
    }

}
